import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

const faqs = [
  {
    q: 'Como faço para criar minha conta?',
    a: 'Acesse dash.waithere.com.br, clique em "Criar conta" e siga o passo a passo. Em menos de 5 minutos seu restaurante estará configurado.',
  },
  {
    q: 'O plano gratuito tem limitações?',
    a: 'O plano gratuito inclui cardápio digital, QR Code e site básico. Para funcionalidades avançadas como pedidos online e gestão de mesas, confira nossos planos pagos.',
  },
  {
    q: 'Como configuro meu cardápio digital?',
    a: 'No painel de gestão, acesse "Cardápio" e adicione categorias e itens. Você pode incluir fotos, descrições, preços e variações para cada produto.',
  },
  {
    q: 'Posso personalizar meu site?',
    a: 'Sim! Você pode editar cores, fontes, banner, fotos e informações de contato diretamente pelo painel. Seu site fica disponível em seurestaurante.wtr.app.br.',
  },
  {
    q: 'Como funciona o sistema de pedidos?',
    a: 'Seus clientes fazem pedidos pelo cardápio digital. Os pedidos aparecem em tempo real no seu painel com detalhes do cliente, itens e forma de entrega.',
  },
  {
    q: 'Posso cancelar minha assinatura a qualquer momento?',
    a: 'Sim, sem multas ou taxas de cancelamento. O acesso ao plano pago permanece até o final do período já faturado.',
  },
  {
    q: 'O WaitHere funciona em qualquer dispositivo?',
    a: 'Sim! Tanto o painel de gestão quanto o cardápio digital dos clientes funcionam em qualquer navegador, em computadores, tablets e celulares.',
  },
  {
    q: 'Como entro em contato com o suporte?',
    a: 'Você pode nos contatar pelo WhatsApp +55 47 98491-6254, pelo e-mail contato@waithere.com.br ou pelo nosso Instagram @waithere.br. Respondemos em até 24 horas úteis.',
  },
]

export default function Suporte() {
  return (
    <div className="min-h-screen bg-white text-black">
      <SEO
        title="Suporte"
        description="Central de suporte WaitHere. Perguntas frequentes e canais de contato — WhatsApp, e-mail e redes sociais."
        path="/suporte"
      />
      <nav className="sticky top-0 z-50 bg-white/97 backdrop-blur-md border-b border-neutral-200">
        <div className="flex items-center justify-between px-5 py-4 md:px-10 lg:px-16">
          <Link to="/" className="no-underline">
            <img src="/waitherelogo.png" alt="Waithere" className="h-7 w-auto" />
          </Link>
          <Link
            to="/"
            className="text-sm text-neutral-500 no-underline hover:text-black transition-colors"
          >
            ← Voltar ao início
          </Link>
        </div>
      </nav>

      <main className="max-w-3xl mx-auto px-5 py-16 sm:px-8 lg:px-0">
        <h1 className="text-3xl sm:text-4xl font-bold mb-3">Central de Suporte</h1>
        <p className="text-neutral-500 text-lg mb-12">
          Encontre respostas para as perguntas mais frequentes ou entre em contato com nossa equipe.
        </p>

        <section className="mb-16">
          <h2 className="text-xl font-semibold mb-6">Perguntas frequentes</h2>
          <div className="space-y-5">
            {faqs.map((faq, i) => (
              <details
                key={i}
                className="group border border-neutral-200 rounded-xl px-5 py-4 cursor-pointer"
              >
                <summary className="font-medium text-[15px] list-none flex items-center justify-between gap-4">
                  {faq.q}
                  <span className="text-neutral-400 group-open:rotate-45 transition-transform text-xl leading-none">+</span>
                </summary>
                <p className="mt-3 text-neutral-600 text-[15px] leading-relaxed">{faq.a}</p>
              </details>
            ))}
          </div>
        </section>

        <section className="bg-neutral-50 rounded-2xl p-8 sm:p-10">
          <h2 className="text-xl font-semibold mb-2">Precisa de mais ajuda?</h2>
          <p className="text-neutral-500 mb-6">
            Nossa equipe está pronta para ajudar você com qualquer dúvida.
          </p>
          <div className="grid sm:grid-cols-2 gap-4">
            <a
              href="mailto:contato@waithere.com.br"
              className="flex items-center gap-3 bg-white border border-neutral-200 rounded-xl px-5 py-4 no-underline hover:border-black transition-colors"
            >
              <span className="text-2xl">✉️</span>
              <div>
                <p className="font-medium text-sm text-black">E-mail</p>
                <p className="text-neutral-500 text-sm">contato@waithere.com.br</p>
              </div>
            </a>
            <a
              href="https://www.instagram.com/waithere.br"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-white border border-neutral-200 rounded-xl px-5 py-4 no-underline hover:border-black transition-colors"
            >
              <span className="text-2xl">📱</span>
              <div>
                <p className="font-medium text-sm text-black">Instagram</p>
                <p className="text-neutral-500 text-sm">@waithere.br</p>
              </div>
            </a>
            <a
              href="https://wa.me/5547984916254"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-white border border-neutral-200 rounded-xl px-5 py-4 no-underline hover:border-black transition-colors"
            >
              <span className="text-2xl">💬</span>
              <div>
                <p className="font-medium text-sm text-black">WhatsApp</p>
                <p className="text-neutral-500 text-sm">+55 47 98491-6254</p>
              </div>
            </a>
            <a
              href="https://www.facebook.com/share/1Nusjwxxz3/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-white border border-neutral-200 rounded-xl px-5 py-4 no-underline hover:border-black transition-colors"
            >
              <span className="text-2xl">👍</span>
              <div>
                <p className="font-medium text-sm text-black">Facebook</p>
                <p className="text-neutral-500 text-sm">Waithere Sahel</p>
              </div>
            </a>
          </div>
        </section>
      </main>
    </div>
  )
}
